import type {
  CandidateFilterOptions,
  CandidateListResponse,
  CandidateQuery,
} from '@/types/candidate';

const backendUrl = process.env.REACT_APP_BACKEND_URL ?? '';

export const buildCandidateQuery = (query: CandidateQuery, withPagination = true) => {
  const params = new URLSearchParams();
  if (withPagination) {
    params.set('page', String(query.page));
    params.set('limit', String(query.limit));
  }
  if (query.dateFrom) params.set('dateFrom', query.dateFrom);
  if (query.dateTo) params.set('dateTo', query.dateTo);
  if (query.fullName.trim()) params.set('fullName', query.fullName.trim());
  if (query.storeIds.length) params.set('storeIds', query.storeIds.join(','));
  if (query.statuses.length) params.set('statuses', query.statuses.join(','));
  params.set('sortBy', query.sortBy);
  params.set('sortOrder', query.sortOrder);
  return params.toString();
};

const authorizedFetch = async (path: string, token?: string): Promise<Response> => {
  const response = await fetch(`${backendUrl}${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });
  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message ?? 'Не удалось получить данные кандидатов');
  }
  return response;
};

export const getCandidates = async (
  query: CandidateQuery,
  token?: string,
): Promise<CandidateListResponse> => {
  const response = await authorizedFetch(`/api/candidate?${buildCandidateQuery(query)}`, token);
  return response.json();
};

export const getCandidateFilters = async (token?: string): Promise<CandidateFilterOptions> => {
  const response = await authorizedFetch('/api/candidate/filters', token);
  return response.json();
};

export const exportCandidates = async (query: CandidateQuery, token?: string): Promise<void> => {
  const response = await authorizedFetch(
    `/api/candidate/export?${buildCandidateQuery(query, false)}`,
    token,
  );
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `Кандидаты_${new Date().toISOString().slice(0, 10)}.xlsx`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
